export const enum Platform {
  MAC = 'mac',
  WIN = 'win',
  WEB = 'web',
}

export const PlatformMap = {
  [Platform.WEB]: '2',
  [Platform.WIN]: '16',
  [Platform.MAC]: '18',
};

export const RPCCallerIdMap = {
  [Platform.WEB]: '30000010',
  [Platform.WIN]: '3000005',
  [Platform.MAC]: '3000003',
};

export const getAppVersion = () => {
  const APP_VERSION = import.meta.env.EVO
    ? vn.external.getUNRequestManagerInitializeParam().versionName
    : '';
  return APP_VERSION;
};

export const getPlatform = () => {
  if (import.meta.env.EVO) {
    return vn.external.osType() === 'mac' ? Platform.MAC : Platform.WIN;
  }
  return Platform.WEB;
};

export const getPlatformId = () => PlatformMap[getPlatform()];
